import { render, staticRenderFns } from "./visitDashboard.vue?vue&type=template&id=52c3a9d8&scoped=true"
import script from "./visitDashboard.vue?vue&type=script&lang=js"
export * from "./visitDashboard.vue?vue&type=script&lang=js"
import style0 from "./visitDashboard.vue?vue&type=style&index=0&id=52c3a9d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c3a9d8",
  null
  
)

export default component.exports